var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.34 0.959961H4.65996C2.61756 0.959961 0.959961 2.61756 0.959961 4.65996V28.34C0.959961 30.3824 2.61756 32.04 4.65996 32.04H28.34C30.3824 32.04 32.04 30.3824 32.04 28.34V4.65996C32.04 2.61756 30.3824 0.959961 28.34 0.959961ZM10.58 12.8V26.86H6.13996V12.8H10.58ZM6.13996 8.70776C6.13996 7.67176 7.02796 6.87996 8.35996 6.87996C9.69196 6.87996 10.5282 7.67176 10.58 8.70776C10.58 9.74376 9.75116 10.58 8.35996 10.58C7.02796 10.58 6.13996 9.74376 6.13996 8.70776ZM26.86 26.86H22.42C22.42 26.86 22.42 20.0076 22.42 19.46C22.42 17.98 21.68 16.5 19.83 16.4704H19.7708C17.98 16.4704 17.24 17.9948 17.24 19.46C17.24 20.1334 17.24 26.86 17.24 26.86H12.8V12.8H17.24V14.6944C17.24 14.6944 18.6682 12.8 21.5394 12.8C24.4772 12.8 26.86 14.8202 26.86 18.9124V26.86Z",
    fill: "#DCDCDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.af583549180a63dd054a31498877704d.svg";
export { ForwardRef as ReactComponent };